// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Qnzz","selects":"Documents_selects__fJ__Q"};